import { Link } from "react-router-dom";
import { BadgeCheck, MapPin, Star } from "lucide-react";
import { inr } from "@/lib/api";
import { useLang, actLabel } from "@/lib/i18n";

export const Avatar = ({ c, className = "" }) =>
  c.photo_url ? (
    <img src={c.photo_url} alt={c.display_name} className={`object-cover ${className}`} loading="lazy" />
  ) : (
    <div className={`grid place-items-center bg-emerald-900 text-emerald-50 font-display text-4xl ${className}`}>{c.display_name?.[0]}</div>
  );

export const CompanionCard = ({ c, acts = [] }) => {
  const { t, lang } = useLang();
  return (
    <Link to={`/companions/${c.id}`} data-testid={`companion-card-${c.id}`} className="group card-surface overflow-hidden flex flex-col hover:-translate-y-1 hover:shadow-xl hover:shadow-emerald-900/10 transition-[transform,box-shadow] duration-300">
      <div className="relative aspect-[4/5] overflow-hidden">
        <Avatar c={c} className="w-full h-full group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute top-3 left-3 flex gap-2">
          {c.is_demo && <span className="demo-badge" data-testid="demo-badge">DEMO</span>}
        </div>
        <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
          {c.verified && <span className="verified-badge bg-white/95"><BadgeCheck size={14} />{t("verified")}</span>}
          <span className="rounded-full bg-slate-900/80 text-white px-2.5 py-1 text-xs font-semibold flex items-center gap-1">
            <Star size={12} className="fill-amber-400 text-amber-400" />{c.rating?.toFixed(1)} <span className="opacity-70">({c.review_count})</span>
          </span>
        </div>
      </div>
      <div className="p-5 flex flex-col gap-3 flex-1">
        <div className="flex items-baseline justify-between gap-2">
          <h3 className="text-2xl font-semibold text-slate-900">{c.display_name}, <span className="font-sans text-lg text-slate-500">{c.age}</span></h3>
        </div>
        <p className="text-sm text-slate-500 flex items-center gap-1"><MapPin size={14} />{c.city} · {c.languages.slice(0, 2).join(", ")}</p>
        <div className="flex flex-wrap gap-1.5">
          {c.activities.slice(0, 3).map((s) => (
            <span key={s} className="chip">{actLabel(acts.find((a) => a.slug === s), lang) || s}</span>
          ))}
        </div>
        <div className="mt-auto pt-3 border-t border-slate-100 flex items-center justify-between">
          <span className="font-mono text-lg font-semibold text-[#0D5C46]" data-testid="companion-card-price">{inr(c.hourly_rate)}<span className="text-xs text-slate-500">{t("per_hour")}</span></span>
          <span className="text-sm font-semibold text-slate-900 group-hover:text-[#0D5C46]">{t("book_now")} →</span>
        </div>
      </div>
    </Link>
  );
};
